export function sortByObjectKey(array: {}[], prop: string, reverse: boolean = false): any {
  return array.sort((a: any, b: any) => {
    if (a[prop] < b[prop]) { return reverse ? 1 : -1 }
    if (a[prop] > b[prop]) { return reverse ? -1 : 1 }
    return 0
  })
}

export function objectPropertyExistsInArray(value: string, array: [], property: string): boolean {
  return array.some((el) => {
    return el[property] === value
  })
}
